import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OccupationQuickMatchModel } from '@cpd-app/core-module/models';
import { OccupationMicroService } from '@cpd-app/core-module/services/occupation';

import * as LocationActions from './location.actions';

@Injectable()
export class LocationEffects {
  constructor(
    private actions$: Actions,
    private occupationMicroService: OccupationMicroService
  ) {}

  setLocation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocationActions.setLocation),
      switchMap((action) => {
        return this.occupationMicroService
          .getOccupationListByLocation(action.locationModel)
          .pipe(
            map((occupationList: OccupationQuickMatchModel[]) =>
              LocationActions.receivedOccupationList({
                entities: occupationList
              })
            ),
            catchError((error) =>
              of(LocationActions.loadOccupationListFailure({ error }))
            )
          );
      })
    );
  });
}
